import React from "react";
import { utcToLocalDateTime } from "./rampChecklistTime";
import MobileDateTimePicker from "./MobileDateTimePicker";

const dash = (value) => (value === null || value === undefined || value === "" ? "—" : value);

/**
 * 航班信息网格（纸质表表头风格）：细边框 + 灰底标签 + 成对显示，时间带月-日、跨日可辨。
 * ATD / ATA 就地可填：有编辑权限时直接点这一行的时间弹出选择器填写（省去下面再开两个字段），
 * 只存检查单、不回写航段主数据；没填时占位提示系统值。其余项只读。
 */
export default function FlightInfoGrid({ flight = {}, headerAttrs = {}, tzId, tzFallback = false, mobile = false, editable = false, header = null, anchorDate, onPatch }) {
    const t = (iso) => (iso ? utcToLocalDateTime(iso, tzId, "MM-DD HH:mm") : "—");

    const handleTime = (field, iso) => {
        if (!editable || !header || !onPatch) return;
        const previous = headerAttrs[field] ?? null;
        if (iso === previous) return;
        onPatch(header.item_id, { [field]: iso }, header.lock_version);
    };

    const timeField = (field) => (
        <MobileDateTimePicker
            value={headerAttrs[field]}
            onChange={(iso) => handleTime(field, iso)}
            tzId={tzId}
            anchorDate={anchorDate}
            placeholder={flight[field] ? t(flight[field]) : "点击填写"}
        />
    );

    const atdAta = editable ? (
        <span style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: 2, margin: "-3px 0" }}>
            {timeField("atd")}
            <span style={{ color: "#ccc" }}>/</span>
            {timeField("ata")}
        </span>
    ) : (
        `${t(headerAttrs.atd || flight.atd)} / ${t(headerAttrs.ata || flight.ata)}`
    );

    const rows = [
        { label: "Flight / REG", value: `${dash(flight.flight_no)} / ${dash(flight.aircraft_reg)}` },
        { label: "Date / Route", value: `${dash(flight.flight_date)} · ${dash(flight.dep)} → ${dash(flight.arr)}` },
        { label: "STD / STA", value: `${t(flight.std)} / ${t(flight.sta)}` },
        { label: "ETD / ETA", value: `${t(flight.etd)} / ${t(flight.eta)}` },
        { label: "ATD / ATA", value: atdAta },
        { label: "Timezone", value: `${tzId || "—"}${tzFallback ? " (local)" : ""}` },
    ];

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: `${mobile ? 104 : 110}px 1fr`,
                fontSize: mobile ? 14 : 13,
                background: "#fff",
            }}
        >
            {rows.map((row, idx) => {
                const bottom = idx === rows.length - 1 ? "none" : "1px solid #f0f0f0";
                return (
                    <React.Fragment key={row.label}>
                        <div
                            style={{
                                background: "#fafafa",
                                fontWeight: 600,
                                color: "#666",
                                padding: "7px 10px",
                                borderRight: "1px solid #f0f0f0",
                                borderBottom: bottom,
                                whiteSpace: "nowrap",
                            }}
                        >
                            {row.label}
                        </div>
                        <div style={{ padding: "7px 10px", borderBottom: bottom, wordBreak: "break-word" }}>{row.value}</div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}
